<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="640">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small text v-bind="attrs" v-on="on">
          Upload Files to Storage
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Upload Files to Storage
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <span v-if="session">Working with {{ session.name }}</span>
            </v-col>
          </v-row>
          <v-form ref="frmRegister">
            <v-file-input v-model="files" 
              placeholder="Upload files" 
              label="File input" 
              multiple
              accept=".pdf"
              prepend-icon="mdi-paperclip">
              <template v-slot:selection="{ text }">
                <v-chip small label color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-progress-linear v-if="uploadedPercent" :value="uploadedPercent" striped height="10"></v-progress-linear>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="uploadFiles">
            Upload & store
          </v-btn>
          <v-btn color="error" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
  export default {
    data: () => ({
      files: [],
      dialog: false,
      uploadedPercent: 0
    }),
    computed: {
      ...mapState('session', ['session'])
    },
    methods: {
      uploadFiles() {
        if (this.files.length >= 1) {
          var data = new FormData()
          for (let file of this.files) {
            data.append("file", file, file.name);
          }
          if(this.session) {
            data.append("client_id", this.session.id)
            data.append("user_id", this.session.id)
          }
          var that = this
          this.$axios({
            method: 'post',
            url: 'storage',
            data: data,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: function (event) {
              that.uploadedPercent = (event.loaded / event.total) * 100
            }
          }).then(res => {
            if(res.data.message) {
              this.$toastr.e(res.data, res.data)
            } else {
              res.data.forEach(file => {
                this.$toastr.s('Uploaded & saved: ' + file.name)
              })
            }
            this.files = []
            this.uploadedPercent = 0
            this.dialog = false
            // this.$router.go()
          }).catch(err => {
            this.$toastr.e(err)
            this.uploadedPercent = 0
            // this.$router.go()
          })
        } else {
          this.$toastr.e('You must select a file.')
        }
      }
    }
  }
</script>